import { apiClient } from '~/services/api-service';
import { Id } from '~/types/common';

export const pdfMicrositeAPIService = {
  getPdfSite: (id: Id) => {
    return apiClient.get(`/microsite/pdf/${id}/`);
  },
  createPdfSite: (body) => {
    return apiClient.post(`/microsite/pdf/`, body);
  },
  replacePdfSite: ({ id, body }: { id: Id; body: any }) => {
    return apiClient.put(`/microsite/pdf/${id}/`, body);
  },
  updatePdfSite: (body, id: Id) => {
    return apiClient.patch(`/microsite/pdf/${id}/`, body);
  },
  createPdfFiles: (body) => {
    return apiClient.post(`/microsite/microsite-pdf/files/`, body);
  },
  updatePdfFiles: (body, id: Id) => {
    return apiClient.patch(`/microsite/microsite-pdf/files/${id}/`, body);
  },
  deletePdfFiles: (id: Id) => {
    return apiClient.delete(`/microsite/microsite-pdf/files/${id}/`);
  },
  uploadSinglePdfFile: (body) => {
    return apiClient.post(`/microsite/microsite-pdf/files/`, body);
  },
};
